<div class="wrapper confinement">
  <div class="back-link-container content-box-only-width">
    <a routerLink=".." class="back-on-mobile mat-h2 back-link">
      <mat-icon class="back-link-icon">arrow_back</mat-icon>{{ 'DASHBOARD.MODIFY_DATA' | translate }}</a
    >
  </div>
  <mat-card class="confinement">
    <mat-card-title>{{ 'ACCOUNT.CHANGE_EMAIL.TITLE' | translate }}</mat-card-title>
    <mat-card-content>
      <div>
        <p>{{ 'ACCOUNT.CHANGE_EMAIL.CURRENT_EMAIL' | translate }}:&nbsp;{{ currentEmail$ | async }}</p>
        <p class="email-info-text mat-card-info">
          {{ 'ACCOUNT.CHANGE_EMAIL.INFO' | translate }}
        </p>
      </div>
      <ng-container *ngIf="changeEmailFormState$ | async as formState">
        <div class="form-container">
          <form [ngrxFormState]="formState">
            <mat-form-field class="form-field" appearance="fill">
              <mat-label>{{ 'ACCOUNT.CHANGE_EMAIL.NEW_EMAIL' | translate }}</mat-label>
              <input matInput type="email" [ngrxFormControlState]="formState.controls.newMail" />
            </mat-form-field>
            <mat-form-field class="form-field" appearance="fill">
              <mat-label>{{ 'ACCOUNT.CHANGE_EMAIL.REPEAT_EMAIL' | translate }}</mat-label>
              <input matInput type="email" [ngrxFormControlState]="formState.controls.repeatMail" />
              <mat-error></mat-error>
            </mat-form-field>
          </form>
          <div class="submit-button-wrapper">
            <button mat-flat-button color="primary" (click)="onSubmit()">
              {{ 'GENERAL.SAVE_CHANGE' | translate }}
            </button>
          </div>
        </div>
      </ng-container>
    </mat-card-content>
  </mat-card>
</div>
